import Model from 'src/app/common/model';

export default class TreatmentTypeModel extends Model {
  id: string;
  name: string;
  others_name?: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
  created_by: string;
  updated_by: string;

  constructor() {
    super();
  }
}
